export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const COMPANIES = 'companies';
export const IMAGE = 'image';
export const IMAGE_RESET = 'imageReset';

export const EMAIL_WORK = 'emailWork';
export const EMAIL_PERSONAL = 'emailPersonal';
export const EMAIL_OTHER = 'emailOther';
export const CONTACT_TYPES = 'contactTypes';
export const CONTACT_POSITION = 'contactPosition'

export const PHONE_WORK = 'phoneWork';
export const PHONE_MOBILE = 'phoneMobile';
export const PHONE_OTHER = 'phoneOther';
export const NOTE = 'note';

export const ADDRESS_WORK = 'addressWork';
export const ADDRESS_WORK_UNIT = 'addressWorkUnit';
export const ADDRESS_WORK_RESET = 'addressWorkReset';
export const ADDRESS_HOME = 'addressHome';
export const ADDRESS_HOME_UNIT = 'addressHomeUnit';
export const ADDRESS_HOME_RESET = 'addressHomeReset';
export const ADDRESS_OTHER = 'addressOther';
export const ADDRESS_OTHER_UNIT = 'addressOtherUnit';
export const ADDRESS_OTHER_RESET = 'addressOtherReset';
export const LANGUAGES = 'languages';
export const UNIT = 'unit';
export const NOTE_RESET = 'noteReset';

export const RESET = 'reset';
export const ROWS_PER_PAGE = 'rowsPerPage';
export const PAGE = 'page';
export const DENSE = 'dense';
export const TABLE_EXTEND = 'tableExtend';

export const CONTACT_CONVERT = 'contactConvert';
